export default __webpack_public_path__ + "ui/assets/img/mnp-20.svg";